import React, {
  useState,
  useEffect,
  useRef,
  useLayoutEffect,
  useImperativeHandle,
  forwardRef,
} from 'react'
import { useSelector, useDispatch } from 'react-redux'
import MD5 from 'js-md5'
import styles from './AIApplications.module.css'
import { Affix, Anchor, Button, Flex, message, Modal } from 'antd'
import HeaderBar from './HeaderBar'
import ListItem from './ListItem'
import {
  cancelCollectCardRequest,
  collectCardRequest,
  getCardInfoListRequest,
} from './AIApplicationsApi'
import bannerImg from './banner.jpg'
import { HTTP_URL } from '../../../util/constants'
import CommentInfoDrawer from './CommentInfoDrawer'
import { setShowPlayerModalStatus, setVideoId } from '../../PlayerModal/PlayerModalSlice'
import { updateAppLogRequest } from './AIApplicationsApi'

// export default function AIApplications(props) {

const AIApplications = forwardRef((props, ref) => {
  //   const count = useSelector(selectCount);
  const dispatch = useDispatch()
  const [messageApi, contextHolder] = message.useMessage()
  const [titleList, setTitleList] = React.useState([
    {
      key: 'keyRemen',
      href: '#card0',
      title: '热门',
    },
  ])
  const [appCardListAll, setAppCardListAll] = useState([])
  const [appCardList, setAppCardList] = useState([])

  const [zpCardWidth, setZpCardWidth] = useState(window.innerWidth - 240 - 98)
  const [anthorPositionTop, setAnthorPositionTop] = useState(0)
  const [searchStr, setSearchStr] = useState('')
  const [drawerStatus, setDrawerStatus] = useState(false)
  const [drawerInfo, setDrawerInfo] = useState({})
  const [pageIndex, setPageIndex] = useState(1)

  const wdzpListRef = useRef(null)
  const anchorRef = useRef(null)

  // const incrementValue = Number(incrementAmount) || 0;

  useEffect(() => {
    // 在这里执行你的组件挂载后的逻辑
    // 这里可以返回一个清理函数，它会在组件卸载前执行
    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
      // console.log('组件即将卸载');
    }
  }, []) // 空数组意味着这个 effect 只会在组件挂载时执行一次
  useImperativeHandle(ref, () => ({
    changePage(page) {
      setTitleList([
        {
          key: 'keyRemen',
          href: '#card0',
          title: '热门',
        },
      ])
      setAppCardList([])
      setAppCardListAll([])
      getCardInfoList(page)
      setPageIndex(page)
      setSearchStr('')
    },
  }))

  useLayoutEffect(() => {
    if (anchorRef.current) {
      // 屏幕宽度 - 左侧菜单栏宽度240 - 左右间距（64*2）* banner图比例214/879算出banner图高度，banner图高度加上顶部bar的高度 120 再加anthor空间高度和下部间距60
      let bannerWidth = window.innerWidth - 240 - 128
      let bannerHeight =
        window.innerWidth - 240 > 1010 ? bannerWidth * (214 / 879) : 216
      // let bannerHeight =window.innerWidth - 240>1010? bannerWidth *0.248:240;
      let anchorTop = bannerHeight + 120 + 110
      setAnthorPositionTop(anchorTop)
    }
  }, [])
  function handleResize() {
    if (wdzpListRef.current) {
      console.log(window.innerWidth)
      const width = wdzpListRef.current.offsetWidth
      setZpCardWidth(width)
    }
    if (anchorRef.current) {
      setAnthorPositionTop(anchorRef.current.offsetTop + 80)
    }
  }

  function getCardInfoList(pageKey) {
    getCardInfoListRequest(pageKey, (data) => {
      if (data.ret == 1) {
        var tempTitleList = [
          {
            key: 'keyRemen',
            href: '#cardList0',
            title: '热门',
          },
        ]
        let tempTitleList1 = data.data.erjicard_list.map((item) => {
          return {
            key: 'key' + item.Id,
            href: '#cardList' + item.erji_code,
            title: item.erji_name,
          }
        })
        setTitleList(tempTitleList.concat(tempTitleList1))

        let tempAppList = [
          {
            erji_code: 0,
            erji_name: '热门',
            card_list: data.data.remen,
          },
        ]
        setAppCardListAll(tempAppList.concat(data.data.app_card_list))
        setAppCardList(tempAppList.concat(data.data.app_card_list))
      } else {
        messageApi.open({
          type: 'warning',
          content: data.msg,
        })
      }
    })
  }
  function searchInputChange(e) {
    setSearchStr(e.target.value)
    if (e.target.value.replaceAll(' ', '') == '') {
      setAppCardList(appCardListAll)
    }
  }
  function createBotMethod(params) {
    props.jumpToCreateBot(31)
  }
  function selectItem(params) {
    // if (params.link_url.includes('http')) {
    //   window.open(HTTP_URL + '/app?id=' + params.code)
    // } else {
    //   message.info('请配置应用链接')
    // }

     if (params.link_url.includes('http')) {
        if (params.waibulianjie == '1') {
          updateAppLogRequest(params, (data) => {
            if (data.ret == 1) {
              window.open(params.link_url)
            } else {
              message.info(data.msg)
            }
          })
        } else {
          window.open(HTTP_URL + '/app?id=' + params.code)
        }
      } else {
        message.info('请配置应用链接')
      }
  }
  function collectMethod(params) {
    console.log(params)
    if (params.shoucang_status == 0) {
      collectCardRequest(params.code, (data) => {
        if (data.ret == 1) {
          let tempAppCardList = appCardList.map((item) => {
            let tempCardList = item.card_list.map((item) => {
              if (item.code == params.code) {
                return { ...item, shoucang_status: '1' }
              } else {
                return item
              }
            })
            return {
              card_list: tempCardList,
              erji_code: item.erji_code,
              erji_name: item.erji_name,
            }
          })
          setAppCardList(tempAppCardList)

          let tempAppCardListAll = appCardListAll.map((item) => {
            let tempCardList = item.card_list.map((item) => {
              if (item.code == params.code) {
                return { ...item, shoucang_status: '1' }
              } else {
                return item
              }
            })
            return {
              card_list: tempCardList,
              erji_code: item.erji_code,
              erji_name: item.erji_name,
            }
          })
          setAppCardListAll(tempAppCardListAll)
        } else {
          messageApi.info(data.msg)
        }
      })
    } else {
      cancelCollectCardRequest(params.code, (data) => {
        if (data.ret == 1) {
          let tempAppCardList = appCardList.map((item) => {
            let tempCardList = item.card_list.map((item) => {
              if (item.code == params.code) {
                return { ...item, shoucang_status: '0' }
              } else {
                return item
              }
            })
            return {
              card_list: tempCardList,
              erji_code: item.erji_code,
              erji_name: item.erji_name,
            }
          })
          setAppCardList(tempAppCardList)

          let tempAppCardListAll = appCardListAll.map((item) => {
            let tempCardList = item.card_list.map((item) => {
              if (item.code == params.code) {
                return { ...item, shoucang_status: '0' }
              } else {
                return item
              }
            })
            return {
              card_list: tempCardList,
              erji_code: item.erji_code,
              erji_name: item.erji_name,
            }
          })
          setAppCardListAll(tempAppCardListAll)
        } else {
          messageApi.info(data.msg)
        }
      })
    }
  }

  function playVideo(videoUrl) {
    dispatch(setShowPlayerModalStatus(true))
    dispatch(setVideoId(videoUrl))
  }
  function openDrawer(info) {
    setDrawerStatus(true)
    setDrawerInfo(info)
  }
  return (
    <div
      className={styles.background}
      id={'rightContentAnchor'}
      //  onKeyDown={keyPress}
    >
      {contextHolder}
      <div className={styles.topContainer}>
        <HeaderBar
          searchInputChange={searchInputChange}
          createBot={createBotMethod}
          searchStr={searchStr}
          confirmSearch={(value) => {
            props.globalSearch(value, 1)
          }}
        />
        <img className={styles.bannerImg} src={bannerImg} />

        <div
          id={'AnchorContainer'}
          style={{
            padding: '20px 50px 20px 50px',
            marginTop: '20px',
            paddingBlock: '4px',
          }}
          ref={anchorRef}
        >
          <Anchor
            direction="horizontal"
            items={titleList}
            getContainer={() => document.getElementById('rightContentAnchor')}
            style={{ backgroundColor: '#fef8ed' }}
          />
        </div>
      </div>
      {appCardList.map((item, index) => {
        return (
          <div
            className={styles.pageContainers}
            style={{ marginTop: index === 0 ? 0 : 20 }}
          >
            <div
              id={'cardList' + item.erji_code}
              style={{
                position: 'absolute',
                marginTop: index == 0 ? -anthorPositionTop : -80,
              }}
            ></div>
            <div className={styles.titleTag}>{item.erji_name}</div>
            <div className={styles.itemContainer} ref={wdzpListRef}>
              {item.card_list.map((item1, index) => {
                return (
                  <ListItem
                    info={item1}
                    boxWidth={zpCardWidth}
                    clickMethod={selectItem}
                    collectMethod={collectMethod}
                    playVideo={playVideo}
                    openDrawer={openDrawer}
                  />
                )
              })}
            </div>
          </div>
        )
      })}
      <CommentInfoDrawer
        info={drawerInfo}
        drawerStatus={drawerStatus}
        close={() => {
          setDrawerStatus(false)
        }}
        refreshMethod={(e) => {
          getCardInfoList(pageIndex)
        }}
      />
    </div>
  )
})
export default AIApplications
